import { IEditProduct } from 'types/products'

/** Canonical empty shape for `products.editedProduct` (persist + initial state). */
export const emptyEditedProduct: IEditProduct = {
  id: '',
  sku: '',
  name: '',
  shortName: '',
  isActive: false,
  packshotUrl: '',
  packshotFileName: '',
  packshotAlt: '',
  packshotBucketKey: '',
  openedPackshotUrl: '',
  openedPackshotFileName: '',
  openedPackshotAlt: '',
  openedPackshotBucketKey: '',
  hotpointsUrl: '',
  hotpointsFileName: '',
  hotpointsAlt: '',
  hotpointsMobileAlt: '',
  hotpointsBucketKey: '',
  hotpointsProperties: '',
  dimensionsUrl: '',
  dimensionsBucketKey: '',
  dimensionsFileName: '',
  dimensionsAlt: '',
  dimensionsDescription: '',
  summaryUrl: '',
  summaryBucketKey: '',
  summaryFileName: '',
  summaryAlt: '',
  country: '',
  additionalFields: null,
  mainVideoTitle: '',
  mainVideoYoutubeId: '',
  mainVideoUrl: null,
  mainVideoFileName: null,
  mainVideoBucketKey: null,
  mainVideoDescriptions: '',
  videoFunctions: '',
  bottomVideoYoutubeId: null,
  bottomVideoUrl: null,
  bottomVideoFileName: null,
  bottomVideoBucketKey: null,
  createdAt: '',
  updatedAt: '',
  deletedAt: '',
  productCategory: {
    id: '',
    name: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    brand: {
      id: '',
      name: '',
      createdAt: '',
      updatedAt: '',
      deletedAt: '',
      productCategories: []
    }
  },
  copies: [],
  assets: {
    Banner: [{ id: '' }]
  }
}
